import { Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { RequireAuth } from './RequireAuth';
import {
    accountRoutes,
    checkautoRoutes,
    companyRoutes,
    partsRoutes,
    placementRoutes,
    regionServiceRoutes,
    rentRoutes,
    searchRoutes,
    sellRoutes,
    toolsRoutes,
} from '../constants/routes';
import { useStorageKeyWatcher } from '../hooks/useStorageKeyWatcher';
import ComingSoon from '../components/seo/CommingSoon';
import {
    AboutPage,
    Accessory,
    AccountCabinet,
    AdminImportPage,
    AddAdvert,
    AuthCallback,
    AutoCompanyAdvert,
    AutoCompanyForm,
    Autoschool,
    AutoschoolForm,
    Autoservice,
    AutoserviceForm,
    AveragePricePage,
    Brakes,
    Calculator,
    Carbody,
    Carwash,
    CarwashForm,
    CheckautoCompany,
    CheckautoExample,
    CheckautoReport,
    Companies,
    CompanyAllDetails,
    CompanyAllList,
    ComparePage,
    ContactsPage,
    CountryCalculator,
    DealerAdvert,
    DealerForm,
    Disassembly,
    DisassemblyForm,
    Electric,
    Engine,
    Equipment,
    ExpertCompanyAdvert,
    ExpertCompanyForm,
    FavoritesBike,
    FavoritesCar,
    FavoritesCommercial,
    FavoritesParts,
    ForgotPasswordForm,
    GasEquipment,
    Heating,
    HtmlSitemap,
    InsuranceCompanyAdvert,
    InsuranceCompanyForm,
    Interior,
    LoginForm,
    MainPage,
    Maintenance,
    MarketPage,
    ModelGuidePage,
    NewPasswordForm,
    NewPhoneForm,
    NewsAdvertPage,
    NewsListPage,
    NotFound,
    NudgeActionPage,
    NudgeUnsubscribePage,
    SavedSearchUnsubscribePage,
    Painting,
    PaintingForm,
    PartnerPage,
    PartsAllDetails,
    PartsBikeList,
    PartsCarList,
    PartsCommercialList,
    PartsCompanyAdvert,
    PartsCompanyForm,
    PartsList,
    PaymentFail,
    PaymentHistory,
    PaymentSuccess,
    PlacementAllDetails,
    PlacementAutoServiceForm,
    PlacementAutoservice,
    PlacementBox,
    PlacementBoxForm,
    PlacementCabinet,
    PlacementCarWashForm,
    PlacementCarwash,
    PlacementGarage,
    PlacementGarageForm,
    PlacementPainting,
    PlacementPaintingForm,
    PlacementTyreServiceForm,
    PlacementTyreservice,
    PricingPage,
    PrivacyPolicy,
    QrLanding,
    ReRegistration,
    RentAdvert,
    RentAllDetails,
    RentBikeForm,
    RentBikeList,
    RentCarForm,
    RentCarList,
    RentCommercialForm,
    RentCommercialList,
    RentCompanyForm,
    RentVehicle,
    SearchAllParts,
    SearchAllPartsFull,
    SearchBike,
    SearchBikeParts,
    SearchBikePartsFull,
    SearchCabinetAllPartsFull,
    SearchCabinetBike,
    SearchCabinetBikePartsFull,
    SearchCabinetCar,
    SearchCabinetCarPartsFull,
    SearchCabinetCommercial,
    SearchCabinetCommercialPartsFull,
    SearchCabinetRentBike,
    SearchCabinetRentCar,
    SearchCabinetRentCommercial,
    SearchCar,
    SearchCarParts,
    SearchCarPartsFull,
    SearchCheckautoFull,
    SearchCommercial,
    SearchCommercialParts,
    SearchCommercialPartsFull,
    SearchCompany,
    SearchCompanyFull,
    SearchFullBike,
    SearchFullCar,
    SearchFullCommercial,
    SearchFullRentBike,
    SearchFullRentCar,
    SearchFullRentCommercial,
    SearchPlacement,
    SearchPlacementFull,
    SearchRentBike,
    SearchRentCar,
    SearchRentCommercial,
    SearchService,
    SearchServiceFull,
    SellBike,
    SellBikeAllDetails,
    SellBikeForm,
    SellBikeList,
    SellBikeProForm,
    SellCar,
    SellCarAllDetails,
    SellCarForm,
    SellCarList,
    SellCarProForm,
    SellCommercial,
    SellCommercialAllDetails,
    SellCommercialForm,
    SellCommercialList,
    SellCommercialProForm,
    ServiceCompanyAddForm,
    ServiceCompanyAdvert,
    ServicesAllDetails,
    ServicesCabinet,
    Settings,
    SignupCorporateForm,
    SignupDealerForm,
    SignupUserForm,
    Suspension,
    TermsConditions,
    TopPlacements,
    TopsCompany,
    TopsParts,
    TopsRent,
    TopsSell,
    TopsServices,
    Towtruck,
    TowtruckForm,
    Transmission,
    Tyreservice,
    TyreserviceForm,
    UnsubscribePage,
    Valuator,
    Verificate,
    Wheels,
} from './lazyPages';

// SELL

// RENT

// COMPANY

// ACCOUNT

// CHECKAUTO

// PARTS

// PLACEMENT

// REGION SERVICES
const SellLegacyRedirect = () => {
    const { lang } = useParams();
    return <Navigate to={`/${lang || 'ge'}/add-advert`} replace />;
};

export default () => {
    useStorageKeyWatcher();

    return (
        <Suspense fallback={<ComingSoon text="loading" />}>
            <Routes>
                <Route path="/:lang/auth/callback" element={<AuthCallback />} />
                <Route path="/:lang/news" Component={NewsListPage} />
                <Route path="/:lang/news/:slug" Component={NewsAdvertPage} />
                <Route path="/:lang/add-advert" Component={AddAdvert} />
                <Route path={`/:lang${toolsRoutes.PRICING}`} Component={PricingPage} />
                <Route path="/:lang/compare" Component={ComparePage} />
                <Route
                    path="/:lang/compare/:vehicleType/:brandA/:modelA/vs/:brandB/:modelB"
                    Component={ComparePage}
                />
                <Route
                    path="/:lang/compare/:vehicleType/:brandA/:modelA/vs/:brandB/:modelB/"
                    Component={ComparePage}
                />
                <Route path="/:lang/go" Component={QrLanding} />
                <Route path="/:lang/car" Component={QrLanding} />
                <Route path="/:lang/sell-car" Component={SellLegacyRedirect} />
                <Route
                    path="/:lang/sell-car/:city"
                    Component={SellLegacyRedirect}
                />
                <Route path="/:lang/sell-bike" Component={SellLegacyRedirect} />
                <Route
                    path="/:lang/sell-bike/:city"
                    Component={SellLegacyRedirect}
                />
                <Route
                    path="/:lang/sell-commercial"
                    Component={SellLegacyRedirect}
                />
                <Route
                    path="/:lang/sell-commercial/:city"
                    Component={SellLegacyRedirect}
                />
                <Route path="/:lang/sitemap" Component={HtmlSitemap} />
                {/* Payment routes */}
                <Route
                    path="/:lang/payment-success"
                    Component={PaymentSuccess}
                />
                <Route path="/:lang/payment-fail" Component={PaymentFail} />

                {/* Checkauto routes */}
                <Route
                    path={`/:lang${checkautoRoutes.EXAMPLE}`}
                    Component={CheckautoExample}
                />
                <Route
                    path={`/:lang${checkautoRoutes.REPORT}`}
                    Component={CheckautoReport}
                />

                {/* Search routes */}
                <Route
                    path={`/:lang${searchRoutes.FULL_RENT_CAR}`}
                    Component={SearchFullRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_RENT_CAR}`}
                    Component={SearchCabinetRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_CAR}`}
                    Component={SearchRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_CAR_BRAND}`}
                    Component={SearchRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_CAR_BRAND_CITY}`}
                    Component={SearchRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_CAR_CITY}`}
                    Component={SearchRentCar}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_BIKE}`}
                    Component={SearchRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_BIKE_BRAND}`}
                    Component={SearchRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_BIKE_BRAND_CITY}`}
                    Component={SearchRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_BIKE_CITY}`}
                    Component={SearchRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_RENT_BIKE}`}
                    Component={SearchCabinetRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_RENT_BIKE}`}
                    Component={SearchFullRentBike}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_COMMERCIAL}`}
                    Component={SearchRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_COMMERCIAL_BRAND}`}
                    Component={SearchRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_COMMERCIAL_BRAND_CITY}`}
                    Component={SearchRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.RENT_COMMERCIAL_CITY}`}
                    Component={SearchRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_RENT_COMMERCIAL}`}
                    Component={SearchCabinetRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_RENT_COMMERCIAL}`}
                    Component={SearchFullRentCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_BRAND}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_BRAND_MODEL}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_BRAND_MODEL_YEAR}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_BRAND_CITY}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_BRAND_MODEL_CITY}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_CITY}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CAR_PRICE}`}
                    Component={SearchCar}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_BRAND}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_BRAND_MODEL}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_BRAND_MODEL_YEAR}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_BRAND_CITY}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_BRAND_MODEL_CITY}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.BIKE_CITY}`}
                    Component={SearchBike}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_BRAND}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_BRAND_MODEL}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_BRAND_MODEL_YEAR}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_BRAND_CITY}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_BRAND_MODEL_CITY}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.COMMERCIAL_CITY}`}
                    Component={SearchCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_CAR}`}
                    Component={SearchFullCar}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_CAR}`}
                    Component={SearchCabinetCar}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_BIKE}`}
                    Component={SearchFullBike}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_BIKE}`}
                    Component={SearchCabinetBike}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_COMMERCIAL}`}
                    Component={SearchFullCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_COMMERCIAL}`}
                    Component={SearchCabinetCommercial}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_CHECKAUTO}`}
                    Component={SearchCheckautoFull}
                />
                <Route
                    path={`/:lang${searchRoutes.COMPANY}`}
                    Component={SearchCompany}
                />
                <Route
                    path={`/:lang${searchRoutes.COMPANY_CITY}`}
                    Component={SearchCompany}
                />
                <Route
                    path={`/:lang${searchRoutes.COMPANY_TYPE}`}
                    Component={SearchCompany}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_COMPANY}`}
                    Component={SearchCompanyFull}
                />
                <Route
                    path={`/:lang${searchRoutes.CHECKAUTO}`}
                    Component={CheckautoCompany}
                />
                <Route
                    path={`/:lang${searchRoutes.CHECKAUTO_CITY}`}
                    Component={CheckautoCompany}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS}`}
                    Component={SearchAllParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_CAR}`}
                    Component={SearchCarParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_BIKE}`}
                    Component={SearchBikeParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_COMMERCIAL}`}
                    Component={SearchCommercialParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_CITY}`}
                    Component={SearchAllParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_CAR_CITY}`}
                    Component={SearchCarParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_BIKE_CITY}`}
                    Component={SearchBikeParts}
                />
                <Route
                    path={`/:lang${searchRoutes.PARTS_COMMERCIAL_CITY}`}
                    Component={SearchCommercialParts}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_PARTS_CAR}`}
                    Component={SearchCarPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_PARTS_CAR}`}
                    Component={SearchCabinetCarPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_PARTS_BIKE}`}
                    Component={SearchBikePartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_PARTS_BIKE}`}
                    Component={SearchCabinetBikePartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_PARTS_COMMERCIAL}`}
                    Component={SearchCommercialPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_PARTS_COMMERCIAL}`}
                    Component={SearchCabinetCommercialPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_PARTS_ALL}`}
                    Component={SearchAllPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.CABINET_PARTS_ALL}`}
                    Component={SearchCabinetAllPartsFull}
                />
                <Route
                    path={`/:lang${searchRoutes.PLACEMENT}`}
                    Component={SearchPlacement}
                />
                <Route
                    path={`/:lang${searchRoutes.PLACEMENT_CITY}`}
                    Component={SearchPlacement}
                />
                <Route
                    path={`/:lang${searchRoutes.PLACEMENT_TYPE}`}
                    Component={SearchPlacement}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_PLACEMENT}`}
                    Component={SearchPlacementFull}
                />
                <Route
                    path={`/:lang${searchRoutes.SERVICE}`}
                    Component={SearchService}
                />
                <Route
                    path={`/:lang${searchRoutes.SERVICE_CITY}`}
                    Component={SearchService}
                />
                <Route
                    path={`/:lang${searchRoutes.SERVICE_TYPE}`}
                    Component={SearchService}
                />
                <Route
                    path={`/:lang${searchRoutes.FULL_SERVICE}`}
                    Component={SearchServiceFull}
                />

                {/* Sell routes */}
                <Route
                    path={`/:lang${sellRoutes.CAR}`}
                    Component={SellCarForm}
                />
                <Route
                    path={`/:lang${sellRoutes.CAR_ID}`}
                    Component={SellCar}
                />
                <Route
                    path={`/:lang${sellRoutes.ALL_CAR_ID}`}
                    Component={SellCarAllDetails}
                />
                <Route
                    path={`/:lang${sellRoutes.BIKE}`}
                    Component={SellBikeForm}
                />
                <Route
                    path={`/:lang${sellRoutes.BIKE_ID}`}
                    Component={SellBike}
                />
                <Route
                    path={`/:lang${sellRoutes.ALL_BIKE_ID}`}
                    Component={SellBikeAllDetails}
                />
                <Route
                    path={`/:lang${sellRoutes.COMMERCIAL}`}
                    Component={SellCommercialForm}
                />
                <Route
                    path={`/:lang${sellRoutes.COMMERCIAL_ID}`}
                    Component={SellCommercial}
                />
                <Route
                    path={`/:lang${sellRoutes.ALL_COMMERCIAL_ID}`}
                    Component={SellCommercialAllDetails}
                />
                <Route
                    path={`/:lang${sellRoutes.PRO_CAR}`}
                    Component={SellCarProForm}
                />
                <Route
                    path={`/:lang${sellRoutes.PRO_BIKE}`}
                    Component={SellBikeProForm}
                />
                <Route
                    path={`/:lang${sellRoutes.PRO_COMMERCIAL}`}
                    Component={SellCommercialProForm}
                />

                {/* Rent routes */}
                <Route
                    path={`/:lang${rentRoutes.CAR}`}
                    Component={RentCarForm}
                />
                <Route
                    path={`/:lang${rentRoutes.CAR_ID}`}
                    Component={RentVehicle}
                />
                <Route
                    path={`/:lang${rentRoutes.BIKE}`}
                    Component={RentBikeForm}
                />
                <Route
                    path={`/:lang${rentRoutes.BIKE_ID}`}
                    Component={RentVehicle}
                />
                <Route
                    path={`/:lang${rentRoutes.COMMERCIAL}`}
                    Component={RentCommercialForm}
                />
                <Route
                    path={`/:lang${rentRoutes.COMMERCIAL_ID}`}
                    Component={RentVehicle}
                />
                <Route
                    path={`/:lang${rentRoutes.ALL_ID}`}
                    Component={RentAllDetails}
                />

                {/* Company routes */}
                <Route
                    path={`/:lang${companyRoutes.DEALER}`}
                    element={<RequireAuth><DealerForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.AUTOCOMPANY}`}
                    element={<RequireAuth><AutoCompanyForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.RENTCOMPANY}`}
                    element={<RequireAuth><RentCompanyForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.PARTSCOMPANY}`}
                    element={<RequireAuth><PartsCompanyForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.SERVICE}`}
                    Component={ServiceCompanyAddForm}
                />
                <Route
                    path={`/:lang${companyRoutes.EXPERT}`}
                    element={<RequireAuth><ExpertCompanyForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.INSURANCE}`}
                    element={<RequireAuth><InsuranceCompanyForm /></RequireAuth>}
                />
                <Route
                    path={`/:lang${companyRoutes.RENT_ID}`}
                    Component={RentAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.DEALER_ID}`}
                    Component={DealerAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.AUTOCOMPANY_ID}`}
                    Component={AutoCompanyAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.PARTS_ID}`}
                    Component={PartsCompanyAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.EXPERT_ID}`}
                    Component={ExpertCompanyAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.INSURANCE_ID}`}
                    Component={InsuranceCompanyAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.SERVICE_ID}`}
                    Component={ServiceCompanyAdvert}
                />
                <Route
                    path={`/:lang${companyRoutes.GET_ALL_ID}`}
                    Component={CompanyAllDetails}
                />
                <Route
                    path="/:lang/company/company"
                    Component={CompanyAllList}
                />

                {/* Region service routes */}
                <Route
                    path={`/:lang${regionServiceRoutes.AUTOSERVICE}`}
                    Component={AutoserviceForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.AUTOSERVICE_ID}`}
                    Component={Autoservice}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.PAINTING_ID}`}
                    Component={Painting}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.PAINTING}`}
                    Component={PaintingForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.AUTOSCHOOL}`}
                    Component={AutoschoolForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.AUTOSCHOOL_ID}`}
                    Component={Autoschool}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.DISASSEMBLY}`}
                    Component={DisassemblyForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.DISASSEMBLY_ID}`}
                    Component={Disassembly}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.CARWASH}`}
                    Component={CarwashForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.CARWASH_ID}`}
                    Component={Carwash}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.TYRESERVICE}`}
                    Component={TyreserviceForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.TYRESERVICE_ID}`}
                    Component={Tyreservice}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.TOWTRUCK}`}
                    Component={TowtruckForm}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.TOWTRUCK_ID}`}
                    Component={Towtruck}
                />
                <Route
                    path={`/:lang${regionServiceRoutes.ALL_ID}`}
                    Component={ServicesAllDetails}
                />

                {/* Parts routes */}
                <Route
                    path={`/:lang${partsRoutes.ACCESSORY_ID}`}
                    Component={Accessory}
                />
                <Route
                    path={`/:lang${partsRoutes.CARBODY_ID}`}
                    Component={Carbody}
                />
                <Route
                    path={`/:lang${partsRoutes.MAINTENANCE_ID}`}
                    Component={Maintenance}
                />
                <Route
                    path={`/:lang${partsRoutes.BRAKES_ID}`}
                    Component={Brakes}
                />
                <Route
                    path={`/:lang${partsRoutes.WHEELS_ID}`}
                    Component={Wheels}
                />
                <Route
                    path={`/:lang${partsRoutes.TRANSMISSION_ID}`}
                    Component={Transmission}
                />
                <Route
                    path={`/:lang${partsRoutes.SUSPENSION_ID}`}
                    Component={Suspension}
                />
                <Route
                    path={`/:lang${partsRoutes.GAS_ID}`}
                    Component={GasEquipment}
                />
                <Route
                    path={`/:lang${partsRoutes.INTERIOR_ID}`}
                    Component={Interior}
                />
                <Route
                    path={`/:lang${partsRoutes.EQUIPMENT_ID}`}
                    Component={Equipment}
                />
                <Route
                    path={`/:lang${partsRoutes.ENGINE_ID}`}
                    Component={Engine}
                />
                <Route
                    path={`/:lang${partsRoutes.ELECTRIC_ID}`}
                    Component={Electric}
                />
                <Route
                    path={`/:lang${partsRoutes.HEATING_ID}`}
                    Component={Heating}
                />
                <Route
                    path={`/:lang${partsRoutes.ALL_ID}`}
                    Component={PartsAllDetails}
                />

                {/* Placement routes */}
                <Route
                    path={`/:lang${placementRoutes.AUTOSERVICE}`}
                    Component={PlacementAutoServiceForm}
                />
                <Route
                    path={`/:lang${placementRoutes.AUTOSERVICE_ID}`}
                    Component={PlacementAutoservice}
                />
                <Route
                    path={`/:lang${placementRoutes.BOX}`}
                    Component={PlacementBoxForm}
                />
                <Route
                    path={`/:lang${placementRoutes.BOX_ID}`}
                    Component={PlacementBox}
                />
                <Route
                    path={`/:lang${placementRoutes.CARWASH}`}
                    Component={PlacementCarWashForm}
                />
                <Route
                    path={`/:lang${placementRoutes.CARWASH_ID}`}
                    Component={PlacementCarwash}
                />
                <Route
                    path={`/:lang${placementRoutes.GARAGE}`}
                    Component={PlacementGarageForm}
                />
                <Route
                    path={`/:lang${placementRoutes.GARAGE_ID}`}
                    Component={PlacementGarage}
                />
                <Route
                    path={`/:lang${placementRoutes.TYRESERVICE}`}
                    Component={PlacementTyreServiceForm}
                />
                <Route
                    path={`/:lang${placementRoutes.TYRESERVICE_ID}`}
                    Component={PlacementTyreservice}
                />
                <Route
                    path={`/:lang${placementRoutes.PAINTING}`}
                    Component={PlacementPaintingForm}
                />
                <Route
                    path={`/:lang${placementRoutes.PAINTING_ID}`}
                    Component={PlacementPainting}
                />
                <Route
                    path={`/:lang${placementRoutes.ALL_ID}`}
                    Component={PlacementAllDetails}
                />

                {/* Account routes */}
                <Route
                    path={`/:lang${accountRoutes.TERMS_CONDITIONS}`}
                    Component={TermsConditions}
                />
                <Route
                    path={`/:lang${accountRoutes.PRIVACY}`}
                    Component={PrivacyPolicy}
                />
                <Route
                    path={`/:lang${accountRoutes.ABOUT}`}
                    Component={AboutPage}
                />
                <Route
                    path={`/:lang${accountRoutes.CONTACTS}`}
                    Component={ContactsPage}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTNERS}`}
                    Component={PartnerPage}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTNERS_TOKEN}`}
                    Component={PartnerPage}
                />
                <Route
                    path={`/:lang${accountRoutes.UNSUBSCRIBE_TOKEN}`}
                    Component={UnsubscribePage}
                />
                <Route
                    path={`/:lang${accountRoutes.NUDGE_TOKEN}`}
                    Component={NudgeActionPage}
                />
                <Route
                    path={`/:lang${accountRoutes.NUDGE_UNSUBSCRIBE_TOKEN}`}
                    Component={NudgeUnsubscribePage}
                />
                <Route
                    path={`/:lang${accountRoutes.SAVED_SEARCH_UNSUBSCRIBE_TOKEN}`}
                    Component={SavedSearchUnsubscribePage}
                />
                <Route
                    path={`/:lang${toolsRoutes.CUSTOMS_CALCULATOR}`}
                    Component={Calculator}
                />
                <Route
                    path={`/:lang${toolsRoutes.CUSTOMS_CALCULATOR_COUNTRY}`}
                    Component={CountryCalculator}
                />
                <Route
                    path={`/:lang${toolsRoutes.RE_REGISTRATION}`}
                    Component={ReRegistration}
                />
                <Route
                    path={`/:lang${toolsRoutes.VALUATOR}`}
                    Component={Valuator}
                />
                <Route
                    path={`/:lang${toolsRoutes.VALUATOR}/:vehicleType`}
                    Component={Valuator}
                />
                <Route
                    path={`/:lang${toolsRoutes.MODEL_GUIDE}`}
                    Component={ModelGuidePage}
                />
                <Route
                    path={`/:lang${toolsRoutes.MARKET}`}
                    Component={MarketPage}
                />
                <Route
                    path={`/:lang${toolsRoutes.AVERAGE_PRICE_TYPE_BRAND_MODEL_YEAR}`}
                    Component={AveragePricePage}
                />
                <Route
                    path={`/:lang${toolsRoutes.AVERAGE_PRICE_TYPE_BRAND_MODEL}`}
                    Component={AveragePricePage}
                />
                <Route
                    path={`/:lang${accountRoutes.VERIFICATE}`}
                    Component={Verificate}
                />
                <Route
                    path={`/:lang${accountRoutes.COMPANY}`}
                    Component={Companies}
                />
                <Route
                    path={`/:lang${accountRoutes.GARAGE_CAR}`}
                    Component={SellCarList}
                />
                <Route
                    path={`/:lang${accountRoutes.GARAGE_BIKE}`}
                    Component={SellBikeList}
                />
                <Route
                    path={`/:lang${accountRoutes.GARAGE_COMMERCIAL}`}
                    Component={SellCommercialList}
                />
                <Route
                    path={`/:lang${accountRoutes.RENT_CAR}`}
                    Component={RentCarList}
                />
                <Route
                    path={`/:lang${accountRoutes.RENT_BIKE}`}
                    Component={RentBikeList}
                />
                <Route
                    path={`/:lang${accountRoutes.RENT_COMMERCIAL}`}
                    Component={RentCommercialList}
                />
                <Route
                    path={`/:lang${accountRoutes.PLACEMENT}`}
                    Component={PlacementCabinet}
                />
                <Route
                    path={`/:lang${accountRoutes.SERVICES}`}
                    Component={ServicesCabinet}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTS}/parts`}
                    Component={PartsList}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTS_CAR}`}
                    Component={PartsCarList}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTS_BIKE}`}
                    Component={PartsBikeList}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTS_COMMERCIAL}`}
                    Component={PartsCommercialList}
                />
                <Route
                    path={`/:lang${accountRoutes.FORGOT_PASSWORD}`}
                    Component={ForgotPasswordForm}
                />
                <Route
                    path={`/:lang${accountRoutes.NEW_PASSWORD}`}
                    Component={NewPasswordForm}
                />
                <Route
                    path={`/:lang${accountRoutes.NEW_PHONE}`}
                    Component={NewPhoneForm}
                />
                <Route
                    path={`/:lang${accountRoutes.LOGIN}`}
                    Component={LoginForm}
                />
                <Route
                    path={`/:lang${accountRoutes.SIGNUP_USER}`}
                    Component={SignupUserForm}
                />
                <Route
                    path={`/:lang${accountRoutes.SIGNUP_DEALER}`}
                    Component={SignupDealerForm}
                />
                <Route
                    path={`/:lang${accountRoutes.SIGNUP_CORPORATE}`}
                    Component={SignupCorporateForm}
                />
                <Route
                    path={`/:lang${accountRoutes.SETTINGS}`}
                    element={<RequireAuth><Settings /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.PAYMENT_HISTORY}`}
                    element={<RequireAuth><PaymentHistory /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.FAVORITE_PARTS}`}
                    element={<RequireAuth><FavoritesParts /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.FAVORITE_CAR}`}
                    element={<RequireAuth><FavoritesCar /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.FAVORITE_BIKE}`}
                    element={<RequireAuth><FavoritesBike /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.FAVORITE_COMMERCIAL}`}
                    element={<RequireAuth><FavoritesCommercial /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.SELL_TOPS_ID}`}
                    element={<RequireAuth><TopsSell /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.RENT_TOPS_ID}`}
                    element={<RequireAuth><TopsRent /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.COMPANY_TOPS_ID}`}
                    element={<RequireAuth><TopsCompany /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.SERVICES_TOPS_ID}`}
                    element={<RequireAuth><TopsServices /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.PLACEMENT_TOPS_ID}`}
                    element={<RequireAuth><TopPlacements /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.PARTS_TOPS_ID}`}
                    element={<RequireAuth><TopsParts /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.IMPORT}`}
                    element={<RequireAuth><AdminImportPage /></RequireAuth>}
                />
                <Route
                    path={`/:lang${accountRoutes.CABINET}`}
                    element={<RequireAuth><AccountCabinet /></RequireAuth>}
                />

                {/* Default routes */}
                <Route path="/:lang" element={<MainPage />} />
                <Route path="/" element={<MainPage />} />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};
